<div style="float:left;" [ngStyle]="{'width': 'calc(100% - ' + reduceWidth + 'px)'}"
  class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.biz_relationship">
  <input autocomplete="off" type="text" id="{{elementIds.brn}}" *ngIf="isBrnEditMode && !isReadOnly"
    [ngClass]="brn ? 'en' : ''" class="brn_input" [(ngModel)]="brn"
    placeholder="{{isWithContactNumber ? localService.languageContent.biz_relationship.contact_num : localService.languageContent.biz_relationship.brn}}"
    title="{{isWithContactNumber ? localService.languageContent.biz_relationship.contact_num : localService.languageContent.biz_relationship.brn}}"
    (focusout)="onBrnFocus(false)" (keydown.enter)="onFocusOut()" (input)="onScanned()"
    (keypress)="localService.isNumberOnly($event,numericConfig)" />
  <button style="float:left;top:0px;" class="button_icon button_icon_color " *ngIf="!isBrnEditMode || isReadOnly"
    [disabled]="!lastUserId || lastUserId == ''"
    (click)="localService.showSummary(lastUserId,isCustomerAsBusiness ? 2 : 1)">info</button>
  <div class="brn_display" id="{{elementIds.brn_display}}" *ngIf="!isBrnEditMode || isReadOnly" (click)="onBrnFocus()"
    title="{{isWithContactNumber ? localService.languageContent.biz_relationship.contact_num : localService.languageContent.biz_relationship.brn}}">
    <div class="assign_name" [ngStyle]="{ 'opacity' : brn_name ? 1 : 0.6}"
      [ngClass]="localService.getLanguageCode(brn_language)">
      <div class="assign_name_label">
        {{brn_name ? brn_name : (isWithContactNumber ? localService.languageContent.biz_relationship.contact_num :
        localService.languageContent.biz_relationship.brn)}}
      </div>
      <i *ngIf="!isReadOnly" class="material-icons button brn_clear" id="{{elementIds.brn_clear}}"
        (click)="onClear(true)">clear</i>
    </div>
  </div>
  <app-qr-scanner *ngIf="!isReadOnly && !localService.isHideDummy" (onQrScanned)="onQrScanned($event)"></app-qr-scanner>
  <button *ngIf="!isReadOnly && !isWithContactNumber" id="{{id}}" style="float: right; top: 0px; left: -5px;"
    class="button_icon button_icon_color " (click)="onAddBrn()">search</button>
</div>
<div>
  <span style="display: none;">
    <button id="btnCloseUserAuthenticationFromBizRelation"
      (click)="onCloseUserAuthentication(true)">OnCloseUserAuth</button>
  </span>
  <app-user-authentication [(isOpenPopup)]="isOpenUserAuthentication" [BusinessId]="businessId"
    [phoneNumber]="phoneNumber" [IsForceSave]="isForceSaveUserAuth" [relationshipRole]="relationShipRole"
    [relationShipType]="relationShipType" [isMultiCustomerTypes]="isMultiCustomerTypes"
    (onClose)="onCloseUserAuthentication(false,$event)" [userAuthSaveBtnId]="elementIds.userAuthSaveBtnId"
    [btnIdToTriggerWhileClose]="'btnCloseUserAuthenticationFromBizRelation'"></app-user-authentication>
</div>